import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.167 3v.5H9v13H6.167v2h7.666v-2H11v-13h2.833v-2H6.166V3Z",
		fill: "#000",
		stroke: "#fff"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%0A%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M6.167%203v.5H9v13H6.167v2h7.666v-2H11v-13h2.833v-2H6.166V3Z%22%20fill%3D%22%23000%22%20stroke%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E%0A";
